import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
const dialogStyles = {
    root: {
        position: 'relative',
        height: 'auto'
    },
    main: {
        position: 'fixed',
        zIndex: 999,
        right: 10,
        bottom: 20
    }
};
const dialogContentStyles = {
    header: {
        color: NeutralColors.gray160
    },
    subText: {
        color: NeutralColors.gray130
    }
};
const dialogContentProps = (context)=>{
    return {
        type: DialogType.close,
        title: context.loc('Nps_PreviewModal_Title', 'Can we ask a quick question?'),
        closeButtonAriaLabel: context.loc('Nps_PreviewModal_CloseButton_AriaLabel', 'Close'),
        subText: context.loc('Nps_PreviewModal_SubHeader_Text', 'We’re always looking for ways to improve AppSource. Can you tell us about your experience?'),
        styles: dialogContentStyles
    };
};
const modalMinWidth = '536px';
const modalProps = {
    isModeless: true
};
export const NpsPreviewModal = ({ hidden, onDismiss, onSubmit, context })=>{
    return /*#__PURE__*/ _jsx(Dialog, {
        hidden: hidden,
        dialogContentProps: dialogContentProps(context),
        minWidth: modalMinWidth,
        modalProps: modalProps,
        styles: dialogStyles,
        onDismiss: onDismiss,
        children: /*#__PURE__*/ _jsxs(DialogFooter, {
            children: [
                /*#__PURE__*/ _jsx(PrimaryButton, {
                    text: context.loc('Nps_PreviewModal_SubmitButton_Text', 'Share feedback'),
                    onClick: onSubmit
                }),
                /*#__PURE__*/ _jsx(DefaultButton, {
                    text: context.loc('Nps_PreviewModal_DismissButton_Text', 'Maybe later'),
                    onClick: onDismiss
                })
            ]
        })
    });
};
